module.exports = __webpack_public_path__ + "static/media/bd.5102bab0.svg";